import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "loading"];
import * as React from 'react';
import { Spinner } from '@cian/ui-kit';
import classNames from 'classnames';
import { useTheme } from '../../../utils/themeContext';
import { getButtonThemeClass } from './helpers';
import * as styles from './Button.css';
export var Button = function Button(_ref) {
  var children = _ref.children,
    loading = _ref.loading,
    props = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme();
  var buttonClassNames = classNames(styles['button'], getButtonThemeClass(theme), loading && styles['button--loading']);
  return /*#__PURE__*/React.createElement("button", _extends({
    className: buttonClassNames
  }, props), loading && /*#__PURE__*/React.createElement("span", {
    className: styles['spinner'],
    "data-testid": "button-spinner"
  }, /*#__PURE__*/React.createElement(Spinner, {
    color: "current_color",
    size: 20
  })), /*#__PURE__*/React.createElement("span", {
    className: styles['content']
  }, children));
};